/**
 * Books auth guard.
 *
 * Wraps every `/books/app/*` route so children only mount once we're
 * certain a `books_token` exists in localStorage. Fixes the 401/403 race
 * where child pages fired API calls before we knew the user was
 * authenticated (screenshot bots, direct URL entry, session-expired
 * refreshes, etc.).
 */
import React from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';

const BooksProtectedRoute = ({ children }) => {
  const location = useLocation();
  const token = typeof window !== 'undefined' ? localStorage.getItem('books_token') : null;
  if (!token) {
    const next = encodeURIComponent(location.pathname + location.search);
    return <Navigate to={`/books/login?next=${next}`} replace />;
  }
  return children ?? <Outlet />;
};

export default BooksProtectedRoute;
